import { useNavigate } from 'react-router-dom'
const Try = () => {
  const navigate = useNavigate();
  document.title = "Roop Sweets"
  const changePage = () => {
    navigate('/aboutus');
  }

  return (
    <>
      <div className='outdiv'>

        <div className='test'>
          {/* <img className='decoimg2' src="/images/Deco3.png" alt="" /> */}
          <img className='decoimg2' src="/images/f1.png" alt="" />
          <div>
            <img className='bg1' src="/images/designN.png" alt="not found" />
          </div>

          <div>
            <img className='shopname' src="/images/logoN.png" alt="Shop Name" />
          </div>

          <img className='since1970' src="/images/sinceN.png" alt="Shop Name" />

          <div>
            <img className='bg2' src="/images/designN2.png" alt="not found" />
          </div>
        </div>

        <img title='explore' onClick={changePage} className='exploreimg' src="/images/expmoreN.png" alt="not found" />


        {/* <img className='decoimg1' src="/images/Deco1.png" alt="" /> */}
        <img className='decoimg1' src="/images/f2.png" alt="" />

      </div>
    </>
  );
};

export default Try;
